import { RequestException } from '@/request-exception'
import { useToast } from 'vue-toastification'

export const IMPERSONATION_READ_ONLY_CODE = 'IMPERSONATION_READ_ONLY'

export const IMPERSONATION_READ_ONLY_MESSAGE =
  'This action is not available while impersonating a customer.'

const IMPERSONATION_READ_ONLY_TOAST_DEDUPE_MS = 2000

let lastImpersonationReadOnlyToastAt = 0

type ImpersonationToastTarget = {
  error: (message: string) => unknown
}

export const showImpersonationReadOnlyToast = (
  toast: ImpersonationToastTarget = useToast()
): boolean => {
  const now = Date.now()

  if (
    now - lastImpersonationReadOnlyToastAt <
    IMPERSONATION_READ_ONLY_TOAST_DEDUPE_MS
  ) {
    return false
  }

  lastImpersonationReadOnlyToastAt = now
  toast.error(IMPERSONATION_READ_ONLY_MESSAGE)

  return true
}

export const resetImpersonationReadOnlyToastState = (): void => {
  lastImpersonationReadOnlyToastAt = 0
}

export const isImpersonationReadOnlyError = (error: unknown): boolean => {
  if (error instanceof RequestException) {
    const context = error.context as
      | {
          data?: {
            code?: string
          }
        }
      | undefined

    return (
      (error.status === 403 &&
        context?.data?.code === IMPERSONATION_READ_ONLY_CODE) ||
      error.message === IMPERSONATION_READ_ONLY_MESSAGE
    )
  }

  return (
    error instanceof Error && error.message === IMPERSONATION_READ_ONLY_MESSAGE
  )
}
